export default "__VITE_ASSET__DolFQz0U__"